import BaseExcelService from './BaseExcelService';

class ExamExcelService extends BaseExcelService {
  getBaseUrl() {
    return '~/api/excel/exam';
  }
}

export default new ExamExcelService();
